import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { INVOICE_CODE_ACTIVE_LIST } from "../apiRoutes";

export interface InvoiceCode {
  code: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}
export interface InvoiceCodeResponse {
  data: {
    records: InvoiceCode[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchActiveInvoiceCode = async () => {
  const response = await axiosAuth.get(INVOICE_CODE_ACTIVE_LIST);
  return response.data as InvoiceCodeResponse;
};

export const useGetActiveInvoiceCode = (
  queryParams?: UseQueryOptions<InvoiceCodeResponse, Error, InvoiceCodeResponse, [string]>
) =>
  useQuery<InvoiceCodeResponse, Error, InvoiceCodeResponse, [string]>({
    queryKey: ["invoice-code-active"],
    queryFn: fetchActiveInvoiceCode,
    ...(queryParams as any),
  });


